(function () {
  'use strict';
  if (window.__mjQuickAddInstalledV2) return;
  window.__mjQuickAddInstalledV2 = true;

  function rootPath() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (!root.startsWith('/')) root = '/' + root;
    if (!root.endsWith('/')) root += '/';
    return root;
  }
  function cartUrl() { return rootPath() + 'cart.js?mj_refresh=' + Date.now(); }

  function updateCartCount(cart) {
    var count = Number(cart && cart.item_count || 0);
    document.querySelectorAll('[data-cart-count], [data-cart-item-count], cart-count, .cart-count, .cart-count-bubble, .header__cart__count, .cart-link__bubble').forEach(function (node) {
      if (node.hasAttribute('data-cart-count')) node.setAttribute('data-cart-count', String(count));
      if (node.hasAttribute('data-cart-item-count')) node.setAttribute('data-cart-item-count', String(count));
      if (node.tagName.toLowerCase() === 'cart-count' || node.matches('.cart-count, .cart-count-bubble, .header__cart__count, .cart-link__bubble')) {
        node.textContent = String(count);
        node.setAttribute('aria-label', count + ' article' + (count === 1 ? '' : 's') + ' dans le panier');
        if (node.matches('.cart-count-bubble, .header__cart__count, .cart-link__bubble')) node.hidden = count < 1;
      }
    });
    document.dispatchEvent(new CustomEvent('mj:cart-updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  // Feedback stays inside the clicked button; never insert a loose message beneath a product card.
  function buttonLabel(button, text) {
    var label = button && button.querySelector('.mj-quick-add-btn__label');
    if (label) label.textContent = text;
  }

  async function readCart() {
    var response = await fetch(cartUrl(), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Impossible de vérifier le panier.');
    return response.json();
  }

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form || !form.matches('.mj-quick-add-form')) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var button = form.querySelector('.mj-quick-add-btn');
    if (!button || button.disabled) return;
    var originalLabel = button.getAttribute('data-quick-add-label') || 'Ajouter au panier';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    buttonLabel(button, 'Ajout…');
    var before = null;
    try { before = await readCart(); } catch (ignore) { /* a successful add response remains authoritative */ }

    try {
      var response = await fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
        credentials: 'same-origin',
        cache: 'no-store'
      });
      var payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || 'Impossible d’ajouter cet article.');

      // Shopify may briefly return a stale cart snapshot. Retry before refreshing the visible count.
      var cart = null;
      var confirmed = false;
      for (var attempt = 0; attempt < 4; attempt++) {
        try { cart = await readCart(); } catch (ignore) { cart = null; }
        if (cart && (!before || Number(cart.item_count || 0) > Number(before.item_count || 0))) { confirmed = true; break; }
        await new Promise(function (resolve) { window.setTimeout(resolve, 180 + attempt * 120); });
      }

      if (cart && confirmed) {
        updateCartCount(cart);
      } else {
        // If cart.js briefly returns a stale snapshot, reflect the successful POST immediately.
        var fallbackCount = Number(before && before.item_count || 0) + Number(payload.quantity || 1);
        updateCartCount({ item_count: fallbackCount, items: [] });
      }

      // Broadcast listens for this event and refreshes its complete cart drawer
      // without a full page reload. Keep the tier bar in sync with the same action.
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('mj:cart-updated', { detail: { cart: cart && confirmed ? cart : null } }));

      buttonLabel(button, 'Ajouté ✓');
      button.classList.add('is-added');
      window.setTimeout(function () {
        buttonLabel(button, originalLabel);
        button.classList.remove('is-added');
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 1300);
    } catch (error) {
      buttonLabel(button, 'Réessayer');
      button.setAttribute('aria-label', (error && error.message) || 'Échec de l’ajout');
      window.setTimeout(function () {
        buttonLabel(button, originalLabel);
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 1800);
    }
  }, true);
})();
